import { i18n } from 'i18n/i18n'
import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { updateUserTrackers } from 'utils/updateUserTrackers'
import { loadDataFromUserAppStartup } from './loadDataFromUserAppStartup'

export const loadAppStartupData = async () => {
  await loadDataFromUserAppStartup()

  const { email, language, id: userId } = userDetailsStore.getState()

  await i18n.globalLng.changeLanguage(i18n.findClosestLanguage([language]))

  if (!HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD) updateUserTrackers({ email, userId: Number(userId) })
}
